var map = {
	"./clippy": 85,
	"./clippy.svg": 85,
	"./color": 86,
	"./color.svg": 86,
	"./front": 87,
	"./front.jpg": 87,
	"./logo": 58,
	"./logo.png": 58,
	"./logo.svg": 159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;